import { Carousel, CarouselIndicators, CarouselItem } from "reactstrap";
import React, { useState } from "react";

export const CarouselInstrucciones = () => {
    const items = [
        {
            id: 1,
            content: (
                <div>
                    <p>
                        Antes de proceder, asegúrate de tener a mano todos los documentos requeridos por tu aseguradora
                        para presentar tu siniestro, cerciórate de subirlos o tomarles una foto en el siguiente orden:
                    </p>
                    <br />
                    <p>Formulario de reclamación o alcance debidamente lleno y firmado por el titular y el médico</p>
                    <ul>
                        <li>Recetas médicas</li>
                        <li>Facturas</li>
                        <li>Historias clínicas</li>
                        <li>Resultados de exámenes</li>
                    </ul>

                    <p>
                        Si el archivo excede el límite de 20MB, favor dividirlo y compilarlo en varios archivos (puedes
                        subir hasta 5 archivos por siniestro)
                    </p>
                </div>
            ),
        },
        {
            id: 2,
            content: (
                <div>
                    El nombre de tu archivo de PDF debe seguir el siguiente formato: <i>ApellidoTitular_Incapacidad</i>.
                    Ejemplo: <strong>Romero_Esguince</strong>
                </div>
            ),
        },
        {
            id: 3,
            content: (
                <div>
                    Confirma, complementa y edita si es necesario, los datos requeridos en el formulario a continuación.
                    <br />
                    <strong>
                        Los documentos deben subirse de la forma señalada, caso contrario no podrán ser procesados
                    </strong>
                </div>
            ),
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);

    const next = () => {
        if (animating) return;
        const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };

    const previous = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };

    const goToIndex = newIndex => {
        if (animating) return;
        setActiveIndex(newIndex);
    };

    const slides = (items || []).map((item, index) => {
        return (
            <CarouselItem onExiting={() => setAnimating(true)} onExited={() => setAnimating(false)} key={item.id}>
                <div className={"carousel-caption"}>
                    <div className={"container text-primary"}>
                        <span className={"counter"}>0{index + 1}</span>
                        <div className={"text-left"}>{item.content}</div>
                    </div>
                </div>
            </CarouselItem>
        );
    });

    return (
        <Carousel interval={10000} activeIndex={activeIndex} next={next} previous={previous}>
            <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
            {slides}
            {/* <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous}/>
            <CarouselControl direction="next" directionText="Next" onClickHandler={next}/>*/}
        </Carousel>
    );
};
